import { BrowserOptions } from "@sentry/nextjs";

const SENTRY_DSN =
  process.env.NEXT_PUBLIC_SENTRY_DSN ||
  "https://61f205bd5f1b4323968b1eeaa0fd9d34@o1254013.ingest.sentry.io/6421765";

const SENTRY_ENV = process.env.NEXT_PUBLIC_SENTRY_ENV || "development";

/**
 * Sentry Configuration for Co.tribute Shell
 */
export const SentryConfig: BrowserOptions = {
  environment: SENTRY_ENV,
  dsn: SENTRY_DSN,
  tracesSampleRate: 1.0,
};
